import {Box, Skeleton} from "@mui/material";
import React from "react";

export const SkeletonStyled = ({type}) => {

    const opacities =
        [
            {opacity: "0.5"},
            {opacity: "0.4"},
            {opacity: "0.3"},
            {opacity: "0.2"},
        ]

    return (
        <>
            {opacities.map((opacity, idx) => {
                return (
                    <Box key={idx} sx={{mb: "0.5rem",}}>
                        {type === 'rectangle' && (
                            <Skeleton variant="rectangular" height={100} sx={opacity}/>
                        )}
                    </Box>
                );
            })}
        </>
    );
};
